import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import Button from 'components/field/Button';
import StringInput from 'components/field/StringInput';
import Form from 'components/form/Form';
import FormItem from 'components/form/FormItem';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import { updateDynamicListData } from 'components/list/dynamicListSlice';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { usePrompt } from 'hooks/usePrompt';

import { WMS_MODULE } from 'services/consts';

import AppLogger from 'utils/AppLogger';
import { DYNAMICLISTS } from 'utils/constants';

const AttributesGroupForm = NiceModal.create(({ setGroup }) => {
	const [isLoading, setIsLoading] = useState(false);
	const modal = useModal();
	const axiosPrivate = useAxiosPrivate();
	const dispatch = useDispatch();

	const { showSuccess, showError } = useAlert();

	const schema = useMemo(
		() =>
			yup
				.object()
				.shape({
					groupName: yup.string().nullable().required()
				})
				.required(),
		[]
	);

	const formMethods = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			groupName: null
		}
	});

	const {
		handleSubmit,
		formState: { isDirty, isSubmitting, isSubmitSuccessful }
	} = formMethods;

	usePrompt(isDirty && !isSubmitting && !isSubmitSuccessful);

	const onSubmit = (data) => {
		setIsLoading(true);

		axiosPrivate
			.post(WMS_MODULE.ADD_ATTRIBUTES_GROUP, data)
			.then((response) => {
				const { status } = response;

				if (status === 200) {
					showSuccess();
					setGroup && setGroup(response.data.productGroupId);
					dispatch(updateDynamicListData(DYNAMICLISTS.ATTRIBUTES_GROUPS));
					modal.remove();
				}
			})
			.catch((error) => {
				if (error.response.data.code === 'error.W006') {
					showError({ message: 'errorMsg.uniqueAttributeName' });
				} else {
					showError();
				}
				AppLogger.error(error);
			})
			.finally(() => setIsLoading(false));
	};

	return (
		<Modal fullwidth maxWidth="x-small" className="modal-attributes-group">
			<ModalTitle>
				<Typography variant="p1">addAttributesGroup</Typography>
			</ModalTitle>
			<ModalContent>
				<Form formMethods={formMethods} borderless>
					<FormItem label="groupName" required isLoading={isLoading}>
						<StringInput name="groupName" />
					</FormItem>
				</Form>
			</ModalContent>

			<ModalActions>
				<Button label="cancel" variant="outline" onClick={() => modal.remove()} />

				<Button
					loading={isLoading}
					onClick={handleSubmit(onSubmit, (errors) => {
						AppLogger.log(errors);
					})}
					disabled={!isDirty}
					disabledTooltip={!isDirty && 'formInfo.noChanges'}
					label={'button.add'}
				/>
			</ModalActions>
		</Modal>
	);
});

export default AttributesGroupForm;
